import { Button } from "ui/components/Button/Button";
import { useTranslate } from "helpers";
import { VehicleGalleryHeaderProps } from "./types";

const VehicleGalleryHeader = ({ onAdd }: VehicleGalleryHeaderProps) => {
    const { t } = useTranslate();

    return (
        <div className="flex items-center gap-2">
            <Button
                size="small"
                variant="secondary"
                startIcon="/media/icons/plus.svg"
                onClick={onAdd}
            >
                {t("admin.fleet.vehicle.gallery.add")}
            </Button>
        </div>
    );
};

export default VehicleGalleryHeader;
